export default __webpack_public_path__ + "static/media/IC00039-explore_org.9e918520.svg";